module.exports = __webpack_public_path__ + "static/media/audiomack.665110bd.pdf";